const LOOPBACK_HOSTS = new Set(['localhost', '[::1]'])

function isLoopbackUrl(value: string) {
  let url: URL
  try {
    url = new URL(value)
  } catch {
    return false
  }
  const host = url.hostname.toLowerCase()
  return LOOPBACK_HOSTS.has(host) || /^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)
}

// Only loopback backends count as dev. Anything else, or anything unparseable, is treated as production.
// `/api` goes through the dev server proxy, so it is as safe as the proxy target.
export function isProductionApiBase(base: string, proxyTarget: string) {
  return !isLoopbackUrl(base === '/api' ? proxyTarget : base)
}
